import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { FormHelperText as MuiFormHelperText } from '@material-ui/core';
import useStyles from './FormHelperText.styles';
const FormHelperText = /*#__PURE__*/forwardRef(function FormHelperText(props, ref) {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(MuiFormHelperText, Object.assign({
    className: classes.root
  }, props, {
    ref: ref
  }));
});
FormHelperText.propTypes = {
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,
  /**
   *  The CSS class name added to the root of the component.
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool
};
export default FormHelperText;